export default function DownloadCTA() {
  return (
    <section id="download" className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20amber%20gradient%20abstract%20background%20with%20comic%20halftone%20dots%20pattern%2C%20soft%20geometric%20shapes%2C%20modern%20tech%20feel%2C%20energetic%20vibrant%20atmosphere%2C%20digital%20illustration%20style&width=1800&height=700&seq=download-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-900/80" />
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4">
          随时随地，畅享漫画
        </h2>
        <p className="text-sm md:text-base text-white/70 max-w-md mx-auto mb-6 md:mb-8">
          下载51漫画APP，海量漫画资源免费离线阅读，支持iOS与安卓双平台
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-8 md:mb-10">
          <a
            href="#"
            className="flex items-center gap-3 px-6 py-3 bg-white text-foreground-900 rounded-xl font-medium hover:bg-white/90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-apple-fill text-2xl" />
            <div className="text-left">
              <div className="text-[10px] opacity-60">Download on the</div>
              <div className="text-sm font-bold">App Store</div>
            </div>
          </a>
          <a
            href="#"
            className="flex items-center gap-3 px-6 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-xl font-medium hover:bg-white/20 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-android-fill text-2xl" />
            <div className="text-left">
              <div className="text-[10px] opacity-60">Download for</div>
              <div className="text-sm font-bold">Android</div>
            </div>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-white/60 text-xs md:text-sm">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-green-400" />
            <span>安全无毒</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-smartphone-line" />
            <span>iOS / 安卓</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-download-2-line" />
            <span>免费下载</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-cloud-off-line" />
            <span>离线阅读</span>
          </div>
        </div>
      </div>
    </section>
  );
}